import React, { PureComponent } from 'react';
import styled, { css } from 'styled-components';

export default class Loading extends PureComponent {

  constructor() {
    super();
    this.svg = React.createRef();
  }

  componentDidMount() {
    const drip = this.svg.current.querySelector('.drip');
    const drop = this.svg.current.querySelector('.drop');
    const [drop1, drop2, drop3] = drop.children;

    this.loaderTl = new TimelineMax({ repeat: -1, repeatDelay: 0.2 });

    this.loaderTl
      .from(drip, 0.4, { scaleX: 0.8, transformOrigin: '50% 50%', y: -40, ease: Power2.easeOut })
      .to(drip, 0.6, { y: 105, ease: Power3.easeIn })
      .to(drip, 0.1, { scaleX: 2, scaleY: 0.5, transformOrigin: '50% 100%' }, '-=.1')
      .set(drip, { opacity: 0 })
      .set(drop, { opacity: 1 })
      .add('droping')
      .to(drop1, 0.2, { y: -30, ease: SlowMo.ease.config(0.1, 1, true) }, 'droping')
      .to(drop2, 0.3, { y: -35, ease: SlowMo.ease.config(0.1, 1, true) }, 'droping')
      .to(drop3, 0.4, { y: -90, ease: SlowMo.ease.config(0.1, 1, true) }, 'droping')
      .to(drop1, 0.2, { x: -40, transformOrigin: '50% 50%', ease: Power0.easeNone }, 'droping')
      .to(drop2, 0.3, { x: 30, transformOrigin: '50% 50%', ease: Power0.easeNone }, 'droping')
      .to(drop3, 0.4, { x: 20, ease: Power0.easeNone }, 'droping')
      .to(drop1, 0.1, { scale: 0, ease: Power3.easeIn }, 'droping+=.1')
      .to(drop2, 0.1, { scale: 0, ease: Power3.easeIn }, 'droping+=.2')
      .to(drop3, 0.1, { scale: 0, ease: Power3.easeIn }, 'droping+=.3');
  }

  componentWillUnmount() {
    this.loaderTl.kill();
  }

  render() {
    const { fluid, align } = this.props;

    return (
      <Loader fluid={fluid} align={align}>
        <svg ref={this.svg} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 342 320">
          <g fill="currentColor">
            <path d="M96.5 180.6l-17.9-54.3H59.3l-17.9 54.3-16.5-54H0l.9 2.7L31 218.1h19.6l18.1-52.5 18.1 52.5h19.6l31-91.5h-24.3zM316.6 126.6l-16.5 54-17.9-54.3h-19.4l-17.9 54.3-16.5-54h-24.9l1 2.7 30.1 88.8h19.6l18.1-52.5 18.1 52.5h19.5l31.1-91.5z" />
            <path className="drip" d="M153.2 198c0 9.6 7.8 17.4 17.4 17.4 9.6 0 17.4-7.8 17.4-17.4.3-14.8-17.4-20.9-17.4-35 0 14.2-17.4 19.4-17.4 35z" />
            <path d="M245.7 22.3c-23.8 0-43.2 19.4-43.2 43.2v1.8h24.7v-1.8c0-10.2 8.3-18.5 18.5-18.5s18.5 8.3 18.5 18.5S255.9 84 245.7 84l-60.7.2V0h-25.5L84.1 87.3v21.4h72l.1 41H185l-.1-41 60.7.1c23.8 0 43.2-19.4 43.2-43.2s-19.3-43.3-43.1-43.3zm-89.6 61.9h-36.5l36.5-42.8v42.8z" />
            <g className="drop" opacity="0">
              <circle className="drop-1" cx="166" cy="310" r="10" />
              <circle className="drop-2" cx="176" cy="310" r="10" />
              <circle className="drop-3" cx="171" cy="310" r="10" />
            </g>
          </g>
        </svg>
      </Loader>
    );
  }
}

const Loader = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  background-color: #fff;
  align-items: center;
  justify-content: ${props => props.align || 'center'};

  svg {
    width: 100%;
    max-width: 150px;
  }

  ${props => props.fluid && css`
    height: auto;
    padding: 15px 0;

    svg {
      max-width: 90px;
    }
  `}
`;

